import environment from '@square/environment-utils/environment';
export function logToConsole(eventProps) {
  // When not running in prod environment, log the user journey event to console for debugging
  if (environment().isDevelopment || environment().isStaging) {
    const {
      action,
      userJourneyName,
      frustrationSignals = [],
      frictionSignals = [],
      tags = [],
      variant,
      outcome
    } = eventProps;
    const actionExecuted = action?.toUpperCase() || outcome || 'STARTED';

    // eslint-disable-next-line no-console
    console.log(`%cUSER JOURNEY:%c ${actionExecuted} ${userJourneyName} ${variant || ''} ${frustrationSignals.length > 0 ? `frustrationSignals:${frustrationSignals.join(',')}` : ''} ${frictionSignals.length > 0 ? `frictionSignals:${frictionSignals.join(',')}` : ''} ${tags.length > 0 ? `tags:${tags.join(',')}` : ''}`, 'color: green;', '' // reset style for the rest of the text
    );
  }
}